import { render, staticRenderFns } from "./RuleGrid.vue?vue&type=template&id=0672dda2&"
import script from "./RuleGrid.vue?vue&type=script&lang=js&"
export * from "./RuleGrid.vue?vue&type=script&lang=js&"
import style0 from "./RuleGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports